import { curryN, equals, pipe, props, join } from "ramda";

export const isDisabled = category => {
  if (category.isStatic) {
    return false;
  }

  return category.count === 0 && category.subCategories.every(isDisabled);
};

export const isEqual = curryN(2, (categoryA, categoryB) => {
  if (categoryA && categoryB) {
    return (
      equals(categoryA.fullTitle, categoryB.fullTitle) &&
      equals(categoryA.type, categoryB.type) &&
      equals(categoryA.view, categoryB.view)
    );
  }

  return false;
});

const fullTitleToTree = fullTitle =>
  fullTitle.split(">").map(title => title.replace(/\*$/, ""));

export const isInPath = (category, activeCategory) => {
  if (!(category && activeCategory)) return false;
  if (isEqual(category, activeCategory)) return true;

  const activeCatTree = fullTitleToTree(activeCategory.fullTitle);
  const catTree = fullTitleToTree(category.fullTitle);

  return equals(catTree, activeCatTree.slice(0, catTree.length));
};

export const trimFullTitle = fullTitle =>
  fullTitle
    .split(">")
    .map(title => title.trim())
    .join(">");

export const getId = category =>
  pipe(props(["title", "type", "view"]), join("_"))(category);

export default {
  isDisabled,
  isEqual,
  getId,
  trimFullTitle,
  isInPath
};
